import React from 'react';
import { Card, Badge, EmptyState } from '@tadagram/ui';
import { useMarketplaceEngine } from '../hooks/useMarketplaceEngine';
import { ListingStatus } from '../domain/marketplaceTypes';
import { Package } from 'lucide-react';

function getPlatform(item: string, title: string, platform?: string) {
  if (item !== 'seeding') return null;
  if (platform) return platform;
  const t = title.toLowerCase();
  if (t.includes('facebook') || t.includes('fb')) return 'facebook';
  if (t.includes('tiktok') || t.includes('tt')) return 'tiktok';
  if (t.includes('instagram') || t.includes('ig')) return 'instagram';
  if (t.includes('zalo')) return 'zalo';
  return 'khác';
}

const MyListings: React.FC = () => {
  const { sellingProducts, isSyncing } = useMarketplaceEngine();

  return (
    <div className="flex flex-col gap-4">
      {isSyncing && (
        <p className="text-sm text-slate-500 m-0">Đang đồng bộ...</p>
      )}

      {sellingProducts.length === 0 && !isSyncing && (
        <Card className="py-16 flex flex-col items-center justify-center text-slate-500">
          <Package className="w-12 h-12 mb-3 opacity-40" />
          <p className="font-medium text-slate-700 m-0">Bạn chưa đăng sản phẩm nào</p>
          <p className="text-sm mt-2 m-0">Chuyển sang tab <strong className="font-semibold text-slate-700">Đăng bán</strong> để tạo sản phẩm đầu tiên</p>
        </Card>
      )}

      <div className="flex flex-col gap-3">
        {sellingProducts.map((item) => {
          return (
            <Card key={item.id} className="p-4 flex gap-4 items-start hover:shadow-md transition-shadow">
              {/* Icon */}
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-100 to-purple-50 flex items-center justify-center text-xl font-bold text-indigo-600 shrink-0">
                {item.banner || item.title.slice(0, 2).toUpperCase()}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-center gap-2 flex-wrap mb-1">
                  <span className="font-bold text-slate-900 truncate">{item.title}</span>
                  <Badge variant={item.status === 'active' ? 'success' : item.status === 'suspended' ? 'danger' : 'warning'}>
                    {item.status === 'active' ? 'Đang mở bán' : item.status === 'suspended' ? 'Tạm khóa' : 'Chờ duyệt'}
                  </Badge>
                </div>
                
                <div className="flex gap-2 flex-wrap text-xs text-slate-500 items-center">
                  <span>{item.type === 'ai' ? 'AI Account' : 'Seeding Account'}</span>
                  {getPlatform(item.type, item.title, item.platform) && (
                    <>
                      <span>·</span>
                      <span className="uppercase">{getPlatform(item.type, item.title, item.platform)}</span>
                    </>
                  )}
                  <span>·</span>
                  <span className="text-blue-600 font-semibold">{item.credits.toLocaleString('vi-VN')} Credits</span>
                  <span>·</span>
                  <span>Tạo: {item.createdAt}</span>
                </div>
                
                {item.description && (
                  <p className="mt-2 text-sm text-slate-600 m-0 truncate">{item.description}</p>
                )}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MyListings;
